export function consoleErrorMessage(e, msg) {
  if (e.response !== undefined) console.error('%s. Response: %o', msg, e.response);
  else console.error('%s: %o', msg, e);
}

export function toasterErrorMessage(toaster, e, msg) {
  if (e.response !== undefined && e.response.data !== undefined && e.response.data.message !== undefined) toaster(e.response.data.message);
  else if (e.response !== undefined && e.response.data !== undefined) toaster(e.response.data);
  else toaster(msg);
}